import type {
  ChangeGatesManager,
  IsChangeGateEnabled,
} from "./ChangeGatesManager";

let changeGatesManager: ChangeGatesManager | undefined;

export const setChangeGatesManager = (manager?: ChangeGatesManager) => {
  changeGatesManager = manager;
};

export const isChangeGateEnabled: IsChangeGateEnabled = (
  changeGateName: string
): boolean => {
  if (!changeGatesManager) {
    return true;
  }
  return changeGatesManager.isChangeGateEnabled(changeGateName);
};

export const isChangeGatesManagerSet = (): boolean => {
  return !!changeGatesManager;
};
